import { capitalize } from '@cbhq/cds-utils';

export function formatRole(role: string) {
  return capitalize(role.replace('ROLE_', '').toLowerCase());
}
